<template>
  <div class="mine-index">
    <div class="container">
      <div class="container_left">
        <diV class="avatar_wa">
          <el-avatar :size="88" :src="user.avatar"></el-avatar>
          <p class="name">{{ user.nickname }}</p>
        </diV>
        <div class="line_div"></div>
        <div class="bar_wa">
          <sideBar />
        </div>
        <div class="line_div"></div>
        <div class="code_wa">
          <img
            class="code_img"
            :src="require('@/assets/images/common/codeApp.png')"
          />
          <p class="code_p">知鸦通识app，观看收听更方便</p>
        </div>
      </div>
      <div class="container_right">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import sideBar from "@/components/mine/sideBar.vue";
import { defineComponent, onBeforeMount, ref, reactive, toRefs } from "vue";
export default defineComponent({
  name: "index",
  components: {
    sideBar,
  },
  setup() {
    const user = ref<any>({});
    onBeforeMount(() => {
      user.value = localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo") as string)
        : {};
    });
    return {
      user,
    };
  },
});
</script>
<style lang="less" scoped>
@import "@/assets/styles/common.less";
.mine-index {
  background: @bg_default;
  overflow: hidden;
  .container {
    width: 1200px;
    margin: 40px auto 65px;
    display: flex;
    justify-content: space-between;
    .container_left {
      width: 20%;
      height: fit-content;
      background: @color_white;
      .avatar_wa {
        text-align: center;
        padding-top: 40px;
        box-sizing: border-box;
        height: 200px;
        width: 100%;
        .name {
          margin-top: 10px;
          font-size: 14px;
          color: #666666;
        }
      }
      .line_div {
        height: 20px;
        background: #efefef;
      }
      .code_wa {
        width: 100%;
        height: 268px;
        padding: 20%;
        box-sizing: border-box;
        text-align: center;
        .code_img {
          width: 100%;
        }
        .code_p {
          font-size: 14px;
          margin-top: 5px;
          color: #666666;
          line-height: 20px;
          width: 100%;
          padding: 0 5px;
          display: block;
          box-sizing: border-box;
        }
      }
    }
    .container_right {
      width: 78%;
      background: @color_white;
    }
  }
}
@media only screen and (max-width: 850px) {
  .mine-index {
    .container {
      width: 100%;
      margin: 0;
      .container_left {
        display: none;
      }
      .container_right {
        width: 100%;
      }
    }
  }
}
</style>

